// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.chat-image[data-v-45e05dec] {
  position: absolute;
  width: 50px;
  top: -30px;
  right: 0px;
  z-index: 4;
}
.nada-text-us-btn[data-v-45e05dec] {
  cursor: pointer;
  text-transform: uppercase;
  font-size: 21px;
  color: #fff;
  text-align: center;
  padding: 14px;
  letter-spacing: 2px;
  display: block;
  margin: 0px auto;
  min-width: 180px;
  border: 3px solid #fff;
  background: #007cc3;
}
.nada-chat-con[data-v-45e05dec] {
  padding: 18px;
  border-radius: 5px;
  border: 1px none #000000;
  box-shadow: 1px 1px 3px 2px rgba(2, 2, 2, 0.19);
  color: #555555;
  z-index: 999999999;
  width: 18%;
  position: fixed;
  bottom: 10px;
  right: 5px;
  min-width: 310px;
  box-sizing: border-box;
}
.nada-child[data-v-45e05dec] {
  box-sizing: border-box;
  margin: 12px 0;
  font-size: 14px;
}
.nadaimg[data-v-45e05dec] {
  max-width: 100%;
  height: auto;
  float: left;
  margin: 4px 10px 0px 0;
  display: block;
  position: relative;
}
.nada-close[data-v-45e05dec] {
  position: absolute;
  right: 0;
  top: 0;
  padding: 8px;
  color: #ffffff;
  font-size: 14px;
  line-height: 14px;
  border: 1px none #ffffff;
  cursor: pointer;
  min-width: 1em;
  z-index: 9999999999;
  border-radius: 0px;
  box-shadow: 0px 0px 0px 0px rgba(2, 2, 2, 0.23);
  text-shadow: 0px 0px 0px rgba(0, 0, 0, 0.23);
}
.nada-bgcolor[data-v-45e05dec] {
  background-color: rgba(0, 144, 178, 1);
}
.nada-color[data-v-45e05dec] {
  color: rgb(0, 144, 178);
}
.nada-main-text[data-v-45e05dec] {
  line-height: 19px;
}
.nada-learn-more[data-v-45e05dec] {
  display: block;
  text-align: center;
  clear: both;
}
.learn-more-btn[data-v-45e05dec] {
  color: #ffffff;
  margin: 0 auto;
  border-radius: 50px;
  cursor: pointer;
  padding: 12px 16px 10px;
  min-width: 70px;
  display: inline-block;
  font-size: 14px;
}
.chat-con[data-v-45e05dec] {
  position: fixed;
  bottom: 50px;
  right: 10px;
  z-index: 1;
}
.chat-con .circle-chat-con[data-v-45e05dec] {
  background: transparent;
  width: 60px;
  height: 60px;
  border-radius: 50%;
  position: relative;
}
.chat-con .circle-chat-con img[data-v-45e05dec] {
  width: 100%;
  height: 100%;
  cursor: pointer;
}
.textwidgetbox[data-v-45e05dec] {
  position: fixed;
  bottom: 50px;
  right: 10px;
  width: 20%;
  background: #fff;
  padding: 20px;
  z-index: 999999999;
  border-radius: 5px;
  border: 1px none #000000;
  box-shadow: 1px 1px 3px 2px rgba(2, 2, 2, 0.19);
  background-color: rgba(254, 254, 254, 1);
}
.textwidgetbox .text-radio-con .text-radio-box .sales-radio-con .float-left[data-v-45e05dec] {
  width: 48%;
}
.textwidgetbox .text-radio-con .text-radio-box .service-radio-con .float-left[data-v-45e05dec] {
  width: 100%;
}
@media (max-width: 1400px) {
.textwidgetbox[data-v-45e05dec] {
    width: 30%;
}
}
@media (max-width: 800px) {
.textwidgetbox[data-v-45e05dec] {
    width: 70%;
}
.send-btn-con .text-send-btn[data-v-45e05dec] {
    margin: 5px 0;
}
.textwidgetbox .note-info-text[data-v-45e05dec] {
    font-size: 11px;
}
.text-radio-con[data-v-45e05dec] {
    margin: 10px 0;
}
.textwidgetbox .text-radio-con .text-radio-box .radio-text[data-v-45e05dec] {
    margin: 5px 0;
    font-size: 11px;
}
}
@media (max-width: 600px) {
.chat-con[data-v-45e05dec] {
    bottom: 25px;
    right: 4px;
    z-index: 1100 !important;
}
.nada-text-us-btn[data-v-45e05dec] {
    cursor: pointer;
    text-transform: uppercase;
    font-size: 20px;
    color: #fff;
    padding: 14px;
    letter-spacing: 2px;
    display: block;
    z-index: 3;
    width: 80%;
    position: fixed;
    bottom: 43px;
    right: 0;
    left: 0;
    text-align: center;
    margin: 0 auto;
}
.nada-chat-con[data-v-45e05dec] {
    width: 97%;
    min-width: unset;
    margin: 0 auto;
}
.textwidgetbox[data-v-45e05dec] {
    width: 80%;
}
.chat-textarea-con[data-v-45e05dec] {
    margin: 10px auto;
}
.textwidgetbox .text-radio-con .text-radio-box .sales-radio-con .float-left[data-v-45e05dec] {
    width: 50%;
}
}
.beforechannelsready[data-v-45e05dec] {
  font-size: 15px;
  color: #000;
}
.f-bold[data-v-45e05dec] {
  font-weight: bold;
}
.textwidgetbox .mobile-number-box .mobile-input input[type="text"][data-v-45e05dec] {
  font-size: 12px;
}
.arrow-left[data-v-45e05dec] {
  width: 0;
  height: 0;
  border-top: 8px solid transparent;
  border-bottom: 8px solid transparent;
  border-right: 15px solid #000;
  margin-right: 5px;
  top: 0;
  position: relative;
}
.chat-buuble-icon[data-v-45e05dec] {
  color: #8bc53f;
  font-size: 25px;
  position: relative;
  top: 2px;
  right: 10px;
}
.textwidget-close-icon[data-v-45e05dec] {
  display: block;
  text-align: right;
  font-size: 24px;
  cursor: pointer;
}
.modal-body .speech-bubble-1[data-v-45e05dec] {
  background: #8bc53f;
}
.modal-body .speech-bubble-1[data-v-45e05dec]:after {
  border-top-color: #8bc53f;
}
.modal-body .speech-bubble-2[data-v-45e05dec] {
  background: #8bc53f;
}
.modal-body .speech-bubble-2[data-v-45e05dec]:after {
  border-top-color: #8bc53f;
}
.channel-list-btns-con ul[data-v-45e05dec] {
  list-style: none;
  padding: 0;
  margin: 0;
}
.text-us-title-con .text-us-title[data-v-45e05dec] {
  color: #8bc53f;
  font-size: 21px;
  font-weight: bold;
  margin-top: 5px;
  position: relative;
}
.text-us-title-con .body-box-chat-icon[data-v-45e05dec] {
  position: relative;
  margin-right: 25px;
}
.back-btn-con[data-v-45e05dec] {
  position: absolute;
  right: 15px;
  top: 10px;
}
.back-btn-con .back-btn-box[data-v-45e05dec] {
  padding: 5px 18px;
  border: 1px solid;
  cursor: pointer;
}
.chat-textarea-con[data-v-45e05dec] {
  width: 80%;
  margin: 20px auto;
  position: relative;
}
.chat-textarea-con[data-v-45e05dec]:before {
  content: "";
  position: absolute;
  border: 15px solid #555;
  left: -30px;
  border-color: #555 #555 transparent transparent;
}
.chat-textarea-con[data-v-45e05dec]:after {
  content: "";
  position: absolute;
  border: 15px solid #555;
  left: -28px;
  border-color: #fff #fff transparent transparent;
  top: 1px;
}
.custom-text-area textarea[data-v-45e05dec] {
  width: 100%;
  padding: 10px 10px 10px 40px;
  box-sizing: border-box;
  background: #f3f3f3;
  border-radius: 5px;
  font-size: 13px;
  border: 1px solid #f3f3f3;
}
.custom-text-area[data-v-45e05dec] {
  position: relative;
}
.custom-text-area .placeholder-icon[data-v-45e05dec] {
  position: absolute;
  top: 38px;
  left: 13px;
}
.custom-text-area .placeholder-icon img[data-v-45e05dec] {
  height: 16px;
}
.custom-text-area textarea[data-v-45e05dec]:focus {
  outline: none;
  border-color: #f3f3f3;
  box-shadow: none;
}
.text-radio-con[data-v-45e05dec] {
  margin: 20px 0;
}
.text-radio-con .intrested-text[data-v-45e05dec] {
  font-weight: bold;
  color: #000;
  margin-bottom: 0;
}
.text-radio-con .text-radio-box .float-left[data-v-45e05dec] {
  width: 40%;
}
.text-radio-con .text-radio-box .radio-text[data-v-45e05dec] {
  margin: 8px 0;
  font-size: 13px;
}
.text-radio-con .text-radio-box .radio-text span[data-v-45e05dec] {
  position: relative;
  top: -2px;
}
.mobile-number-box .mobile-number[data-v-45e05dec] {
  font-weight: normal;
  color: #000;
  margin: 5px 0;
}
.mobile-number-box .phonenumberinput[data-v-45e05dec] {
  width: 100%;
  padding: 10px;
}
.note-info-text[data-v-45e05dec] {
  text-align: center;
  margin: 10px 0;
  font-size: 14px;
}
.send-btn-con[data-v-45e05dec] {
  text-align: center;
}
.send-btn-con .text-send-btn[data-v-45e05dec] {
  background: #8bc53f;
  color: #fff;
  padding: 7px 14px;
  text-align: center;
  cursor: pointer;
  display: inline-block;
  font-size: 15px !important;
  min-width: 120px;
  margin: 10px 0;
  border: 0;
}
.thank-you-con[data-v-45e05dec] {
  font-size: 18px;
  margin: 40px 0;
}
.textwidgetbox .textwidget-close-icon[data-v-45e05dec] {
  position: absolute;
  top: 0px;
  right: 10px;
  font-size: 28px;
  cursor: pointer;
  display: block;
}
.textwidgetbox .back-btn-con[data-v-45e05dec] {
  right: 35px;
}
.cls-2[data-v-45e05dec] {
  fill: url(#linear-gradient);
}
.cls-3[data-v-45e05dec] {
  fill: #fff;
}
.chat-child[data-v-45e05dec] {
  position: relative;
}
@media (max-width: 767px) {
.chat-image[data-v-45e05dec] {
    width: 40px;
}
.note-info-text[data-v-45e05dec] {
    font-size: 10px;
}
}
@media (max-width: 400px) {
.chat-image[data-v-45e05dec] {
    position: absolute;
    width: 35px;
    right: 0px;
    z-index: 4;
}
}
.mobile-number-box .mobile-input .error[data-v-45e05dec] {
  border: 1px solid red;
}
.channel-form[data-v-45e05dec] {
  height: 80vh;
  overflow: auto;
}
.back-button[data-v-45e05dec] {
  border: 1px solid;
  padding: 0px 10px;
}
.sales-radio-con>div[data-v-45e05dec] {
  float: left;
  width: 50%;
}
.service-radio-con>div[data-v-45e05dec] {
  float: left;
  width: 50%;
}
@media (max-width: 500px) {
.salestextareamessage[data-v-45e05dec] {
    height: 100px;
}
.channel-form[data-v-45e05dec] {
    font-size: 14px;
}
}
@media (max-width: 400px) {
.radio-text[data-v-45e05dec] {
    font-size: 10px !important;
}
.channel-form[data-v-45e05dec] {
    font-size: 10px;
}
.mobile-number-box .phonenumberinput[data-v-45e05dec] {
    padding: 4px;
}
.text-radio-con .text-radio-box .radio-text[data-v-45e05dec] {
    margin: 5px 0px;
}
.salestextareamessage[data-v-45e05dec] {
    height: 70px;
}
.text-radio-con[data-v-45e05dec] {
    margin: 0px !important;
}
.arrow-left[data-v-45e05dec] {
    width: 0;
    height: 0;
    border-top: 5px solid transparent;
    border-bottom: 5px solid transparent;
    border-right: 8px solid #000;
    margin-right: 5px;
    top: 2px;
    position: relative;
    font-size: 10px;
}
.text-us-title-con .text-us-title[data-v-45e05dec] {
    margin-top: 0px;
    font-size: 15px;
}
.send-btn-con .text-send-btn[data-v-45e05dec] {
    font-size: 13px !important;
    padding: 5px 14px !important;
    margin: 0px;
}
.textus-title[data-v-45e05dec] {
    font-size: 13px;
}
}
.name-input[data-v-45e05dec] {
  border: 1px solid #dedede !important;
}
.name-input.error[data-v-45e05dec] {
  border: 1px solid red !important;
}
.chat_loader[data-v-45e05dec] {
  box-sizing: border-box;
  display: flex;
  width: 100%;
  height: 24px;
  align-items: center;
  justify-content: center;
}
@-webkit-keyframes ball-pulse-sync-45e05dec {
20% {
    -webkit-transform: translateY(5px);
    transform: translateY(5px);
}
40% {
    -webkit-transform: translateY(-5px);
    transform: translateY(-5px);
}
60% {
    -webkit-transform: translateY(5px);
    transform: translateY(5px);
}
80% {
    -webkit-transform: translateY(-5px);
    transform: translateY(-5px);
}
100% {
    -webkit-transform: translateY(0);
    transform: translateY(0);
}
}
@keyframes ball-pulse-sync-45e05dec {
20% {
    -webkit-transform: translateY(5px);
    transform: translateY(5px);
}
40% {
    -webkit-transform: translateY(-5px);
    transform: translateY(-5px);
}
60% {
    -webkit-transform: translateY(5px);
    transform: translateY(5px);
}
80% {
    -webkit-transform: translateY(-5px);
    transform: translateY(-5px);
}
100% {
    -webkit-transform: translateY(0);
    transform: translateY(0);
}
}
.ball-pulse-sync>div[data-v-45e05dec]:nth-child(1) {
  -webkit-animation: ball-pulse-sync-45e05dec 1s -0.36s infinite ease-in-out;
  animation: ball-pulse-sync-45e05dec 1s -0.36s infinite ease-in-out;
}
.ball-pulse-sync>div[data-v-45e05dec]:nth-child(2) {
  -webkit-animation: ball-pulse-sync-45e05dec 1s -0.27s infinite ease-in-out;
  animation: ball-pulse-sync-45e05dec 1s -0.27s infinite ease-in-out;
}
.ball-pulse-sync>div[data-v-45e05dec]:nth-child(3) {
  -webkit-animation: ball-pulse-sync-45e05dec 1s -0.18s infinite ease-in-out;
  animation: ball-pulse-sync-45e05dec 1s -0.18s infinite ease-in-out;
}
.ball-pulse-sync>div[data-v-45e05dec]:nth-child(4) {
  -webkit-animation: ball-pulse-sync-45e05dec 1s -0.09s infinite ease-in-out;
  animation: ball-pulse-sync-45e05dec 1s -0.09s infinite ease-in-out;
}
.ball-pulse-sync>div[data-v-45e05dec]:nth-child(5) {
  -webkit-animation: ball-pulse-sync-45e05dec 1s 0s infinite ease-in-out;
  animation: ball-pulse-sync-45e05dec 1s 0s infinite ease-in-out;
}
.ball-pulse-sync>div[data-v-45e05dec] {
  width: 5px;
  height: 5px;
  border-radius: 100%;
  margin: 0px;
  -webkit-animation-fill-mode: both;
  animation-fill-mode: both;
  display: inline-block;
}
.text-us-btn[data-v-45e05dec] {
  border-radius: 7px;
  border: solid 1px #e4e4e4;
  background-color: #fff;
  padding: 10px 20px;
  color: #212529;
  margin-bottom: 15px;
  cursor: pointer;
  height: 55px;
  align-items: center;
  justify-content: center;
  display: flex;
}
.radio-button-toolbar[data-v-45e05dec] {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 10px;
}
.radio-button-toolbar input[type="radio"][data-v-45e05dec] {
  opacity: 0;
  position: fixed;
  width: 0;
}
.radio-button-toolbar label[data-v-45e05dec] {
  display: block;
  background-color: #fff;
  padding: 13px;
  font-size: 11px;
  border: 1px solid #dedede;
  border-radius: 5px;
  margin: 0;
  text-align: center;
  cursor: pointer;
}
.radio-button-toolbar label[data-v-45e05dec]:hover {
  background-color: #fefefe;
}
.radio-button-toolbar input[type="radio"]:checked+label[data-v-45e05dec] {
  background-color: #f3f3f3;
  border-color: #333;
  font-weight: 600;
}
.input__hold input[data-v-45e05dec]:focus {
  outline: none;
}
.note-info-text.info_text[data-v-45e05dec] {
  font-size: 11px !important;
  color: #999;
}
.salestextareamessage.error[data-v-45e05dec] {
  border: 1px solid red !important;
}
.my-custom-margin[data-v-45e05dec] {
  margin: 40px 0 35px 0;
}
.custom-padding-t30-b60[data-v-45e05dec] {
  padding: 30px 0 60px 0;
}
.custom-padding-t30[data-v-45e05dec] {
  padding-top: 35px;
}
.custom-padding-t30-b35[data-v-45e05dec] {
  padding: 30px 0 5px 0;
}
@media (min-width: 1900px) {
.send-btn-con .text-send-btn[data-v-45e05dec] {
    height: 50px;
}
}
.new_text_us_form .input__contA[data-v-45e05dec] {
  width: 100%;
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 10px;
  justify-content: flex-start;
  align-items: center;
}
.new_text_us_form.mobile-number-box .name-input.rounded-inputs[data-v-45e05dec] {
  border-radius: 5px !important;
}
.new_text_us_form.mobile-number-box .input__hold[data-v-45e05dec] {
  margin: 0 0 10px 0;
}
.new_text_us_form.mobile-number-box .mobile-number[data-v-45e05dec] {
  color: #999;
  margin: 5px 0;
}
.showOtherTextForm .text__conversation__block.other_Option_Text[data-v-45e05dec] {
  height: auto !important;
}
`, "",{"version":3,"sources":["webpack://./src/Components/ChatWidget/TextusForm/TextusForm.vue"],"names":[],"mappings":";AAkKA;EACE,kBAAkB;EAClB,WAAW;EACX,UAAU;EACV,UAAU;EACV,UAAU;AACZ;AAEA;EACE,eAAe;EACf,yBAAyB;EACzB,eAAe;EACf,WAAW;EACX,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,cAAc;EACd,gBAAgB;EAChB,gBAAgB;EAChB,sBAAsB;EACtB,mBAAmB;AACrB;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,wBAAwB;EACxB,+CAA+C;EAC/C,cAAc;EACd,kBAAkB;EAClB,UAAU;EACV,eAAe;EACf,YAAY;EACZ,UAAU;EACV,gBAAgB;EAChB,sBAAsB;AACxB;AAEA;EACE,sBAAsB;EACtB,cAAc;EACd,eAAe;AACjB;AAEA;EACE,eAAe;EACf,YAAY;EACZ,WAAW;EACX,sBAAsB;EACtB,cAAc;EACd,kBAAkB;AACpB;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,MAAM;EACN,YAAY;EACZ,cAAc;EACd,eAAe;EACf,iBAAiB;EACjB,wBAAwB;EACxB,eAAe;EACf,cAAc;EACd,mBAAmB;EACnB,kBAAkB;EAClB,+CAA+C;EAC/C,4CAA4C;AAC9C;AAEA;EACE,sCAAsC;AACxC;AAEA;EACE,uBAAuB;AACzB;AAEA;EACE,iBAAiB;AACnB;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,WAAW;AACb;AAEA;EACE,cAAc;EACd,cAAc;EACd,mBAAmB;EACnB,eAAe;EACf,uBAAuB;EACvB,eAAe;EACf,qBAAqB;EACrB,eAAe;AACjB;AAEA;EACE,eAAe;EACf,YAAY;EACZ,WAAW;EACX,UAAU;AACZ;AAEA;EACE,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;AACpB;AAEA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;AACjB;AAEA;EACE,eAAe;EACf,YAAY;EACZ,WAAW;EACX,UAAU;EACV,gBAAgB;EAChB,aAAa;EACb,kBAAkB;EAClB,kBAAkB;EAClB,wBAAwB;EACxB,+CAA+C;EAC/C,wCAAwC;AAC1C;AAEA;EACE,UAAU;AACZ;AAEA;EACE,WAAW;AACb;AAEA;AACE;IACE,UAAU;AACZ;AACF;AAEA;AACE;IACE,UAAU;AACZ;AAEA;IACE,aAAa;AACf;AAEA;IACE,eAAe;AACjB;AAEA;IACE,cAAc;AAChB;AAEA;IACE,aAAa;IACb,eAAe;AACjB;AACF;AAEA;AACE;IACE,YAAY;IACZ,UAAU;IACV,wBAAwB;AAC1B;AAEA;IACE,eAAe;IACf,yBAAyB;IACzB,eAAe;IACf,WAAW;IACX,aAAa;IACb,mBAAmB;IACnB,cAAc;IACd,UAAU;IACV,UAAU;IACV,eAAe;IACf,YAAY;IACZ,QAAQ;IACR,OAAO;IACP,kBAAkB;IAClB,cAAc;AAChB;AAEA;IACE,UAAU;IACV,gBAAgB;IAChB,cAAc;AAChB;AAEA;IACE,UAAU;AACZ;AAEA;IACE,iBAAiB;AACnB;AAEA;IACE,UAAU;AACZ;AACF;AAEA;EACE,eAAe;EACf,WAAW;AACb;AAEA;EACE,iBAAiB;AACnB;AAEA;EACE,eAAe;AACjB;AAEA;EACE,QAAQ;EACR,SAAS;EACT,iCAAiC;EACjC,oCAAoC;EACpC,6BAA6B;EAC7B,iBAAiB;EACjB,MAAM;EACN,kBAAkB;AACpB;AAEA;EACE,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,QAAQ;EACR,WAAW;AACb;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,eAAe;EACf,eAAe;AACjB;AAEA;EACE,mBAAmB;AACrB;AAEA;EACE,yBAAyB;AAC3B;AAEA;EACE,mBAAmB;AACrB;AAEA;EACE,yBAAyB;AAC3B;AAEA;EACE,gBAAgB;EAChB,UAAU;EACV,SAAS;AACX;AAEA;EACE,cAAc;EACd,eAAe;EACf,iBAAiB;EACjB,eAAe;EACf,kBAAkB;AACpB;AAEA;EACE,kBAAkB;EAClB,kBAAkB;AACpB;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,SAAS;AACX;AAEA;EACE,iBAAiB;EACjB,iBAAiB;EACjB,eAAe;AACjB;AAEA;EACE,UAAU;EACV,iBAAiB;EACjB,kBAAkB;AACpB;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,uBAAuB;EACvB,WAAW;EACX,+CAA+C;AACjD;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,uBAAuB;EACvB,WAAW;EACX,+CAA+C;EAC/C,QAAQ;AACV;AAEA;EACE,WAAW;EACX,4BAA4B;EAC5B,sBAAsB;EACtB,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,yBAAyB;AAC3B;AAEA;EACE,kBAAkB;AACpB;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,UAAU;AACZ;AAEA;EACE,YAAY;AACd;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,gBAAgB;AAClB;AAEA;EACE,cAAc;AAChB;AAEA;EACE,iBAAiB;EACjB,WAAW;EACX,gBAAgB;AAClB;AAEA;EACE,UAAU;AACZ;AAEA;EACE,aAAa;EACb,eAAe;AACjB;AAEA;EACE,kBAAkB;EAClB,SAAS;AACX;AAEA;EACE,mBAAmB;EACnB,WAAW;EACX,aAAa;AACf;AAEA;EACE,WAAW;EACX,aAAa;AACf;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,eAAe;AACjB;AAEA;EACE,kBAAkB;AACpB;AAEA;EACE,mBAAmB;EACnB,WAAW;EACX,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,qBAAqB;EACrB,0BAA0B;EAC1B,gBAAgB;EAChB,cAAc;EACd,SAAS;AACX;AAEA;EACE,eAAe;EACf,cAAc;AAChB;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,WAAW;EACX,eAAe;EACf,eAAe;EACf,cAAc;AAChB;AAEA;EACE,WAAW;AACb;AAEA;EACE,2BAA2B;AAC7B;AAEA;EACE,UAAU;AACZ;AAEA;EACE,kBAAkB;AACpB;AAEA;AACE;IACE,WAAW;AACb;AAEA;IACE,eAAe;AACjB;AACF;AAEA;AACE;IACE,kBAAkB;IAClB,WAAW;IACX,UAAU;IACV,UAAU;AACZ;AACF;AAEA;EACE,qBAAqB;AACvB;AAEA;EACE,YAAY;EACZ,cAAc;AAChB;AAEA;EACE,iBAAiB;EACjB,iBAAiB;AACnB;AAEA;EACE,WAAW;EACX,UAAU;AACZ;AAEA;EACE,WAAW;EACX,UAAU;AACZ;AAEA;AACE;IACE,aAAa;AACf;AAEA;IACE,eAAe;AACjB;AACF;AAEA;AACE;IACE,0BAA0B;AAC5B;AAEA;IACE,eAAe;AACjB;AAEA;IACE,YAAY;AACd;AAEA;IACE,eAAe;AACjB;AAEA;IACE,YAAY;AACd;AAEA;IACE,sBAAsB;AACxB;AAEA;IACE,QAAQ;IACR,SAAS;IACT,iCAAiC;IACjC,oCAAoC;IACpC,4BAA4B;IAC5B,iBAAiB;IACjB,QAAQ;IACR,kBAAkB;IAClB,eAAe;AACjB;AAEA;IACE,eAAe;IACf,eAAe;AACjB;AAEA;IACE,0BAA0B;IAC1B,4BAA4B;IAC5B,WAAW;AACb;AAEA;IACE,eAAe;AACjB;AACF;AAEA;EACE,oCAAoC;AACtC;AAEA;EACE,gCAAgC;AAClC;AAEA;EACE,sBAAsB;EACtB,aAAa;EACb,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,uBAAuB;AACzB;AAEA;AACE;IACE,kCAAkC;IAClC,0BAA0B;AAC5B;AAEA;IACE,mCAAmC;IACnC,2BAA2B;AAC7B;AAEA;IACE,kCAAkC;IAClC,0BAA0B;AAC5B;AAEA;IACE,mCAAmC;IACnC,2BAA2B;AAC7B;AAEA;IACE,gCAAgC;IAChC,wBAAwB;AAC1B;AACF;AAEA;AACE;IACE,kCAAkC;IAClC,0BAA0B;AAC5B;AAEA;IACE,mCAAmC;IACnC,2BAA2B;AAC7B;AAEA;IACE,kCAAkC;IAClC,0BAA0B;AAC5B;AAEA;IACE,mCAAmC;IACnC,2BAA2B;AAC7B;AAEA;IACE,gCAAgC;IAChC,wBAAwB;AAC1B;AACF;AAEA;EACE,0EAAiE;EACjE,kEAAyD;AAC3D;AAEA;EACE,0EAAiE;EACjE,kEAAyD;AAC3D;AAEA;EACE,0EAAiE;EACjE,kEAAyD;AAC3D;AAEA;EACE,0EAAiE;EACjE,kEAAyD;AAC3D;AAEA;EACE,sEAA6D;EAC7D,8DAAqD;AACvD;AAEA;EACE,UAAU;EACV,WAAW;EACX,mBAAmB;EACnB,WAAW;EACX,iCAAiC;EACjC,yBAAyB;EACzB,qBAAqB;AACvB;AAEA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,sBAAsB;EACtB,kBAAkB;EAClB,cAAc;EACd,mBAAmB;EACnB,eAAe;EACf,YAAY;EACZ,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;AACf;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;AACX;AAEA;EACE,UAAU;EACV,eAAe;EACf,QAAQ;AACV;AAEA;EACE,cAAc;EACd,sBAAsB;EACtB,aAAa;EACb,eAAe;EACf,yBAAyB;EACzB,kBAAkB;EAClB,SAAS;EACT,kBAAkB;EAClB,eAAe;AACjB;AAEA;EACE,yBAAyB;AAC3B;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;AAClB;AAEA;EACE,aAAa;AACf;AAEA;EACE,0BAA0B;EAC1B,WAAW;AACb;AAEA;EACE,gCAAgC;AAClC;AAEA;EACE,qBAAqB;AACvB;AAEA;EACE,sBAAsB;AACxB;AAEA;EACE,iBAAiB;AACnB;AAEA;EACE,qBAAqB;AACvB;AAEA;AACE;IACE,YAAY;AACd;AACF;AAEA;EACE,WAAW;EACX,aAAa;EACb,8BAA8B;EAC9B,SAAS;EACT,2BAA2B;EAC3B,mBAAmB;AACrB;AAEA;EACE,6BAA6B;AAC/B;AAEA;EACE,kBAAkB;AACpB;AAEA;EACE,WAAW;EACX,aAAa;AACf;AAEA;EACE,uBAAuB;AACzB","sourcesContent":["<template>\r\n  <div>\r\n    <template v-if=\"!integrateWithText\">\r\n      <div v-if=\"channellistready\" class=\"beforechannelsready\">\r\n        <!-- {{ displayText }} -->\r\n        <div v-if=\"isLoader\">\r\n          <div class=\"chat_loader\">\r\n            <div class=\"loader-inner ball-pulse-sync\">\r\n              <div class=\"bgcolor-primary theme-bg-color\" />\r\n              <div class=\"bgcolor-primary theme-bg-color\" />\r\n              <div class=\"bgcolor-primary theme-bg-color\" />\r\n              <div class=\"bgcolor-primary theme-bg-color\" />\r\n              <div class=\"bgcolor-primary theme-bg-color\" />\r\n            </div>\r\n          </div>\r\n        </div>\r\n      </div>\r\n      <div v-if=\"isChannelListActive\" class=\"channel-list px-lg-4\">\r\n        <p class=\"ft-13 text-center custom-padding-t30-b60 m-0\">\r\n          <!-- To get started, let us know who you would like to reach and we will connect you with the\r\n          team member. -->\r\n          Please select the department you would like to Text.\r\n        </p>\r\n        <div class=\"\">\r\n          <ul class=\"list-unstyled\">\r\n            <li v-for=\"(channellist, index) in textuschannellistdata\" :key=\"index\">\r\n              <div v-if=\"!checkGooglePresent(channellist.Description)\" tabindex=\"0\"\r\n                class=\"text-center text-us-btn ft-13\" :style=\"{ borderColor: chatThemeSettings?.borderColor }\"\r\n                :data-leadtypeid=\"channellist.LeadTypeId\" :data-accountid=\"channellist.TouchpointAccountId\"\r\n                :data-locationid=\"channellist.TextRequestPhoneNumberId\" :data-dealerphone=\"channellist.PhoneNumber\"\r\n                @click.prevent=\"\r\n                  channellistclick(\r\n                    channellist.LeadTypeId,\r\n                    channellist.TouchpointAccountId,\r\n                    channellist.TextRequestPhoneNumberId,\r\n                    channellist.PhoneNumber,\r\n                    channellist.Description,\r\n                    true\r\n                  )\r\n                  \" @keyup.enter=\"\r\n                    channellistclick(\r\n                      channellist.LeadTypeId,\r\n                      channellist.TouchpointAccountId,\r\n                      channellist.TextRequestPhoneNumberId,\r\n                      channellist.PhoneNumber,\r\n                      channellist.Description\r\n                    )\r\n                    \">\r\n                <span v-if=\"channellist.Description\">{{ channellist.Description }}</span>\r\n              </div>\r\n            </li>\r\n            <li v-if=\"enableOtherTextUs\" class=\"\">\r\n              <div :style=\"{ borderColor: chatThemeSettings?.borderColor }\" class=\"text-center text-us-btn ft-13\"\r\n                tabindex=\"0\" @click.prevent=\"OtherTextForm()\">\r\n                Other\r\n              </div>\r\n            </li>\r\n          </ul>\r\n        </div>\r\n      </div>\r\n\r\n      <div v-if=\"showOtherTextForm\" class=\"showOtherTextForm mt-5 text_us_event_listener\">\r\n        <other-option-text-form :disclaimer=\"footerDisclaimer\" />\r\n      </div>\r\n\r\n      <div v-if=\"islistformactive\" class=\"channel-form px-lg-4 text_us_event_listener\">\r\n        <div v-if=\"listforminitialdisplay\" class=\"initial-con\" @focus.capture=\"onFormFocus\">\r\n          <div class=\"text-center custom-padding-t30\">\r\n            <p class=\"m-0 ft-13\">Please text us your message below.</p>\r\n          </div>\r\n          <div class=\"custom-text-area custom-padding-t30-b35\">\r\n            <div class=\"placeholder-icon\">\r\n              <img class=\"img-fluid\" src=\"/images/chat-widget/text-area-icon.svg\" alt=\"\" />\r\n            </div>\r\n            <textarea v-model.trim=\"textdetails.vTextarea\" class=\"salestextareamessage\" rows=\"6\" name=\"message\"\r\n              placeholder=\"Type your message\" :class=\"[{ error: errordetails.textArea }]\" />\r\n          </div>\r\n          <div class=\"border-bottom my-custom-margin\" />\r\n\r\n          <div class=\"mobile-number-box new_text_us_form\">\r\n            <!-- first name last name -->\r\n            <template v-if=\"setTextAsLeadForm\">\r\n              <div class=\"input__contA\">\r\n                <div class=\"input__hold\">\r\n                  <div class=\"mobile-number\">First Name *</div>\r\n                  <div class=\"mobile-input\">\r\n                    <input v-model.trim=\"firstName\" type=\"text\" name=\"First Name\"\r\n                      class=\"phonenumberinput name-input rounded-inputs\"\r\n                      :class=\"[{ error: errordetails.firstnameerror }]\" />\r\n                  </div>\r\n                </div>\r\n                <div class=\"input__hold\">\r\n                  <div class=\"mobile-number\">Last Name*</div>\r\n                  <div class=\"mobile-input\">\r\n                    <input v-model.trim=\"lastName\" type=\"text\" name=\"Last Name\"\r\n                      class=\"phonenumberinput name-input rounded-inputs\"\r\n                      :class=\"[{ error: errordetails.lastnameerror }]\" />\r\n                  </div>\r\n                </div>\r\n              </div>\r\n            </template>\r\n            <!-- first name last name -->\r\n            <div class=\"input__hold\">\r\n              <div class=\"mobile-number\">Mobile Number*</div>\r\n              <div class=\"mobile-input\">\r\n                <input v-model=\"textdetails.vPhonenumber\" type=\"text\" name=\"Mobile Number\"\r\n                  class=\"phonenumberinput name-input rounded-inputs\" :class=\"[{ error: errordetails.phoneerror }]\"\r\n                  @keypress=\"isNumberKey\" />\r\n              </div>\r\n            </div>\r\n            <div v-if=\"showEmailField\" class=\"input__hold\">\r\n              <div class=\"mobile-number\">Email Address*</div>\r\n              <div class=\"mobile-input\">\r\n                <input v-model=\"textdetails.vEmailAddress\" type=\"text\" name=\"\"\r\n                  class=\"phonenumberinput name-input rounded-inputs\" :class=\"[{ error: errordetails.emailerror }]\" />\r\n              </div>\r\n            </div>\r\n\r\n            <div class=\"input__hold\" v-if=\"showZipCodeField\">\r\n              <div class=\"mobile-number\">{{ zipDetails.placeHolderText }}</div>\r\n              <div class=\"mobile-input\">\r\n                <input v-model=\"textdetails.Zip\" type=\"text\" :name=\"zipDetails.placeHolderText\"\r\n                  class=\"phonenumberinput name-input rounded-inputs\" :class=\"[{ error: errordetails.ziperror }]\" />\r\n              </div>\r\n            </div>\r\n          </div>\r\n          <div class=\"mt-2 pt-3\">\r\n            <tcpa-disclaimer @checked=\"ontcpChecked($event)\" />\r\n          </div>\r\n\r\n          <div class=\"my-2\">\r\n            <show-disclaimer />\r\n          </div>\r\n\r\n          <shift-tcpa-disclaimer-checkbox v-if=\"loadShiftSpecialFields\" :formdata=\"textdetails\"\r\n            :errorobj=\"errordetails\" />\r\n\r\n          <div class=\"send-btn-con\">\r\n            <button id=\"sendbtn\" type=\"button\"\r\n              class=\"_theme_font_bold btn btn-lg btn-block my-3 text-send-btn bgcolor-primary rounded-inputs theme-bg-color btn-websites button-primary\"\r\n              @click.prevent=\"sendtext()\">\r\n              Text Us\r\n              <i class=\"primaryicon-longarrow-right float-right\" style=\"position: relative; top: 4px\"></i>\r\n            </button>\r\n          </div>\r\n        </div>\r\n        <div v-if=\"isthankyou\" class=\"thank-you-con\">\r\n          Thank you, your information has been received and a dealer representative will contact you\r\n          soon!\r\n        </div>\r\n        <div v-if=\"senderror\" class=\"thank-you-con\">\r\n          Something went wrong,Please try again later;\r\n        </div>\r\n      </div>\r\n    </template>\r\n    <integrate-with-text v-else />\r\n  </div>\r\n</template>\r\n\r\n<script type=\"text/javascript\" src=\"./TextusForm.js\"></script>\r\n\r\n<style scoped>\r\n.chat-image {\r\n  position: absolute;\r\n  width: 50px;\r\n  top: -30px;\r\n  right: 0px;\r\n  z-index: 4;\r\n}\r\n\r\n.nada-text-us-btn {\r\n  cursor: pointer;\r\n  text-transform: uppercase;\r\n  font-size: 21px;\r\n  color: #fff;\r\n  text-align: center;\r\n  padding: 14px;\r\n  letter-spacing: 2px;\r\n  display: block;\r\n  margin: 0px auto;\r\n  min-width: 180px;\r\n  border: 3px solid #fff;\r\n  background: #007cc3;\r\n}\r\n\r\n.nada-chat-con {\r\n  padding: 18px;\r\n  border-radius: 5px;\r\n  border: 1px none #000000;\r\n  box-shadow: 1px 1px 3px 2px rgba(2, 2, 2, 0.19);\r\n  color: #555555;\r\n  z-index: 999999999;\r\n  width: 18%;\r\n  position: fixed;\r\n  bottom: 10px;\r\n  right: 5px;\r\n  min-width: 310px;\r\n  box-sizing: border-box;\r\n}\r\n\r\n.nada-child {\r\n  box-sizing: border-box;\r\n  margin: 12px 0;\r\n  font-size: 14px;\r\n}\r\n\r\n.nadaimg {\r\n  max-width: 100%;\r\n  height: auto;\r\n  float: left;\r\n  margin: 4px 10px 0px 0;\r\n  display: block;\r\n  position: relative;\r\n}\r\n\r\n.nada-close {\r\n  position: absolute;\r\n  right: 0;\r\n  top: 0;\r\n  padding: 8px;\r\n  color: #ffffff;\r\n  font-size: 14px;\r\n  line-height: 14px;\r\n  border: 1px none #ffffff;\r\n  cursor: pointer;\r\n  min-width: 1em;\r\n  z-index: 9999999999;\r\n  border-radius: 0px;\r\n  box-shadow: 0px 0px 0px 0px rgba(2, 2, 2, 0.23);\r\n  text-shadow: 0px 0px 0px rgba(0, 0, 0, 0.23);\r\n}\r\n\r\n.nada-bgcolor {\r\n  background-color: rgba(0, 144, 178, 1);\r\n}\r\n\r\n.nada-color {\r\n  color: rgb(0, 144, 178);\r\n}\r\n\r\n.nada-main-text {\r\n  line-height: 19px;\r\n}\r\n\r\n.nada-learn-more {\r\n  display: block;\r\n  text-align: center;\r\n  clear: both;\r\n}\r\n\r\n.learn-more-btn {\r\n  color: #ffffff;\r\n  margin: 0 auto;\r\n  border-radius: 50px;\r\n  cursor: pointer;\r\n  padding: 12px 16px 10px;\r\n  min-width: 70px;\r\n  display: inline-block;\r\n  font-size: 14px;\r\n}\r\n\r\n.chat-con {\r\n  position: fixed;\r\n  bottom: 50px;\r\n  right: 10px;\r\n  z-index: 1;\r\n}\r\n\r\n.chat-con .circle-chat-con {\r\n  background: transparent;\r\n  width: 60px;\r\n  height: 60px;\r\n  border-radius: 50%;\r\n  position: relative;\r\n}\r\n\r\n.chat-con .circle-chat-con img {\r\n  width: 100%;\r\n  height: 100%;\r\n  cursor: pointer;\r\n}\r\n\r\n.textwidgetbox {\r\n  position: fixed;\r\n  bottom: 50px;\r\n  right: 10px;\r\n  width: 20%;\r\n  background: #fff;\r\n  padding: 20px;\r\n  z-index: 999999999;\r\n  border-radius: 5px;\r\n  border: 1px none #000000;\r\n  box-shadow: 1px 1px 3px 2px rgba(2, 2, 2, 0.19);\r\n  background-color: rgba(254, 254, 254, 1);\r\n}\r\n\r\n.textwidgetbox .text-radio-con .text-radio-box .sales-radio-con .float-left {\r\n  width: 48%;\r\n}\r\n\r\n.textwidgetbox .text-radio-con .text-radio-box .service-radio-con .float-left {\r\n  width: 100%;\r\n}\r\n\r\n@media (max-width: 1400px) {\r\n  .textwidgetbox {\r\n    width: 30%;\r\n  }\r\n}\r\n\r\n@media (max-width: 800px) {\r\n  .textwidgetbox {\r\n    width: 70%;\r\n  }\r\n\r\n  .send-btn-con .text-send-btn {\r\n    margin: 5px 0;\r\n  }\r\n\r\n  .textwidgetbox .note-info-text {\r\n    font-size: 11px;\r\n  }\r\n\r\n  .text-radio-con {\r\n    margin: 10px 0;\r\n  }\r\n\r\n  .textwidgetbox .text-radio-con .text-radio-box .radio-text {\r\n    margin: 5px 0;\r\n    font-size: 11px;\r\n  }\r\n}\r\n\r\n@media (max-width: 600px) {\r\n  .chat-con {\r\n    bottom: 25px;\r\n    right: 4px;\r\n    z-index: 1100 !important;\r\n  }\r\n\r\n  .nada-text-us-btn {\r\n    cursor: pointer;\r\n    text-transform: uppercase;\r\n    font-size: 20px;\r\n    color: #fff;\r\n    padding: 14px;\r\n    letter-spacing: 2px;\r\n    display: block;\r\n    z-index: 3;\r\n    width: 80%;\r\n    position: fixed;\r\n    bottom: 43px;\r\n    right: 0;\r\n    left: 0;\r\n    text-align: center;\r\n    margin: 0 auto;\r\n  }\r\n\r\n  .nada-chat-con {\r\n    width: 97%;\r\n    min-width: unset;\r\n    margin: 0 auto;\r\n  }\r\n\r\n  .textwidgetbox {\r\n    width: 80%;\r\n  }\r\n\r\n  .chat-textarea-con {\r\n    margin: 10px auto;\r\n  }\r\n\r\n  .textwidgetbox .text-radio-con .text-radio-box .sales-radio-con .float-left {\r\n    width: 50%;\r\n  }\r\n}\r\n\r\n.beforechannelsready {\r\n  font-size: 15px;\r\n  color: #000;\r\n}\r\n\r\n.f-bold {\r\n  font-weight: bold;\r\n}\r\n\r\n.textwidgetbox .mobile-number-box .mobile-input input[type=\"text\"] {\r\n  font-size: 12px;\r\n}\r\n\r\n.arrow-left {\r\n  width: 0;\r\n  height: 0;\r\n  border-top: 8px solid transparent;\r\n  border-bottom: 8px solid transparent;\r\n  border-right: 15px solid #000;\r\n  margin-right: 5px;\r\n  top: 0;\r\n  position: relative;\r\n}\r\n\r\n.chat-buuble-icon {\r\n  color: #8bc53f;\r\n  font-size: 25px;\r\n  position: relative;\r\n  top: 2px;\r\n  right: 10px;\r\n}\r\n\r\n.textwidget-close-icon {\r\n  display: block;\r\n  text-align: right;\r\n  font-size: 24px;\r\n  cursor: pointer;\r\n}\r\n\r\n.modal-body .speech-bubble-1 {\r\n  background: #8bc53f;\r\n}\r\n\r\n.modal-body .speech-bubble-1:after {\r\n  border-top-color: #8bc53f;\r\n}\r\n\r\n.modal-body .speech-bubble-2 {\r\n  background: #8bc53f;\r\n}\r\n\r\n.modal-body .speech-bubble-2:after {\r\n  border-top-color: #8bc53f;\r\n}\r\n\r\n.channel-list-btns-con ul {\r\n  list-style: none;\r\n  padding: 0;\r\n  margin: 0;\r\n}\r\n\r\n.text-us-title-con .text-us-title {\r\n  color: #8bc53f;\r\n  font-size: 21px;\r\n  font-weight: bold;\r\n  margin-top: 5px;\r\n  position: relative;\r\n}\r\n\r\n.text-us-title-con .body-box-chat-icon {\r\n  position: relative;\r\n  margin-right: 25px;\r\n}\r\n\r\n.back-btn-con {\r\n  position: absolute;\r\n  right: 15px;\r\n  top: 10px;\r\n}\r\n\r\n.back-btn-con .back-btn-box {\r\n  padding: 5px 18px;\r\n  border: 1px solid;\r\n  cursor: pointer;\r\n}\r\n\r\n.chat-textarea-con {\r\n  width: 80%;\r\n  margin: 20px auto;\r\n  position: relative;\r\n}\r\n\r\n.chat-textarea-con:before {\r\n  content: \"\";\r\n  position: absolute;\r\n  border: 15px solid #555;\r\n  left: -30px;\r\n  border-color: #555 #555 transparent transparent;\r\n}\r\n\r\n.chat-textarea-con:after {\r\n  content: \"\";\r\n  position: absolute;\r\n  border: 15px solid #555;\r\n  left: -28px;\r\n  border-color: #fff #fff transparent transparent;\r\n  top: 1px;\r\n}\r\n\r\n.custom-text-area textarea {\r\n  width: 100%;\r\n  padding: 10px 10px 10px 40px;\r\n  box-sizing: border-box;\r\n  background: #f3f3f3;\r\n  border-radius: 5px;\r\n  font-size: 13px;\r\n  border: 1px solid #f3f3f3;\r\n}\r\n\r\n.custom-text-area {\r\n  position: relative;\r\n}\r\n\r\n.custom-text-area .placeholder-icon {\r\n  position: absolute;\r\n  top: 38px;\r\n  left: 13px;\r\n}\r\n\r\n.custom-text-area .placeholder-icon img {\r\n  height: 16px;\r\n}\r\n\r\n.custom-text-area textarea:focus {\r\n  outline: none;\r\n  border-color: #f3f3f3;\r\n  box-shadow: none;\r\n}\r\n\r\n.text-radio-con {\r\n  margin: 20px 0;\r\n}\r\n\r\n.text-radio-con .intrested-text {\r\n  font-weight: bold;\r\n  color: #000;\r\n  margin-bottom: 0;\r\n}\r\n\r\n.text-radio-con .text-radio-box .float-left {\r\n  width: 40%;\r\n}\r\n\r\n.text-radio-con .text-radio-box .radio-text {\r\n  margin: 8px 0;\r\n  font-size: 13px;\r\n}\r\n\r\n.text-radio-con .text-radio-box .radio-text span {\r\n  position: relative;\r\n  top: -2px;\r\n}\r\n\r\n.mobile-number-box .mobile-number {\r\n  font-weight: normal;\r\n  color: #000;\r\n  margin: 5px 0;\r\n}\r\n\r\n.mobile-number-box .phonenumberinput {\r\n  width: 100%;\r\n  padding: 10px;\r\n}\r\n\r\n.note-info-text {\r\n  text-align: center;\r\n  margin: 10px 0;\r\n  font-size: 14px;\r\n}\r\n\r\n.send-btn-con {\r\n  text-align: center;\r\n}\r\n\r\n.send-btn-con .text-send-btn {\r\n  background: #8bc53f;\r\n  color: #fff;\r\n  padding: 7px 14px;\r\n  text-align: center;\r\n  cursor: pointer;\r\n  display: inline-block;\r\n  font-size: 15px !important;\r\n  min-width: 120px;\r\n  margin: 10px 0;\r\n  border: 0;\r\n}\r\n\r\n.thank-you-con {\r\n  font-size: 18px;\r\n  margin: 40px 0;\r\n}\r\n\r\n.textwidgetbox .textwidget-close-icon {\r\n  position: absolute;\r\n  top: 0px;\r\n  right: 10px;\r\n  font-size: 28px;\r\n  cursor: pointer;\r\n  display: block;\r\n}\r\n\r\n.textwidgetbox .back-btn-con {\r\n  right: 35px;\r\n}\r\n\r\n.cls-2 {\r\n  fill: url(#linear-gradient);\r\n}\r\n\r\n.cls-3 {\r\n  fill: #fff;\r\n}\r\n\r\n.chat-child {\r\n  position: relative;\r\n}\r\n\r\n@media (max-width: 767px) {\r\n  .chat-image {\r\n    width: 40px;\r\n  }\r\n\r\n  .note-info-text {\r\n    font-size: 10px;\r\n  }\r\n}\r\n\r\n@media (max-width: 400px) {\r\n  .chat-image {\r\n    position: absolute;\r\n    width: 35px;\r\n    right: 0px;\r\n    z-index: 4;\r\n  }\r\n}\r\n\r\n.mobile-number-box .mobile-input .error {\r\n  border: 1px solid red;\r\n}\r\n\r\n.channel-form {\r\n  height: 80vh;\r\n  overflow: auto;\r\n}\r\n\r\n.back-button {\r\n  border: 1px solid;\r\n  padding: 0px 10px;\r\n}\r\n\r\n.sales-radio-con>div {\r\n  float: left;\r\n  width: 50%;\r\n}\r\n\r\n.service-radio-con>div {\r\n  float: left;\r\n  width: 50%;\r\n}\r\n\r\n@media (max-width: 500px) {\r\n  .salestextareamessage {\r\n    height: 100px;\r\n  }\r\n\r\n  .channel-form {\r\n    font-size: 14px;\r\n  }\r\n}\r\n\r\n@media (max-width: 400px) {\r\n  .radio-text {\r\n    font-size: 10px !important;\r\n  }\r\n\r\n  .channel-form {\r\n    font-size: 10px;\r\n  }\r\n\r\n  .mobile-number-box .phonenumberinput {\r\n    padding: 4px;\r\n  }\r\n\r\n  .text-radio-con .text-radio-box .radio-text {\r\n    margin: 5px 0px;\r\n  }\r\n\r\n  .salestextareamessage {\r\n    height: 70px;\r\n  }\r\n\r\n  .text-radio-con {\r\n    margin: 0px !important;\r\n  }\r\n\r\n  .arrow-left {\r\n    width: 0;\r\n    height: 0;\r\n    border-top: 5px solid transparent;\r\n    border-bottom: 5px solid transparent;\r\n    border-right: 8px solid #000;\r\n    margin-right: 5px;\r\n    top: 2px;\r\n    position: relative;\r\n    font-size: 10px;\r\n  }\r\n\r\n  .text-us-title-con .text-us-title {\r\n    margin-top: 0px;\r\n    font-size: 15px;\r\n  }\r\n\r\n  .send-btn-con .text-send-btn {\r\n    font-size: 13px !important;\r\n    padding: 5px 14px !important;\r\n    margin: 0px;\r\n  }\r\n\r\n  .textus-title {\r\n    font-size: 13px;\r\n  }\r\n}\r\n\r\n.name-input {\r\n  border: 1px solid #dedede !important;\r\n}\r\n\r\n.name-input.error {\r\n  border: 1px solid red !important;\r\n}\r\n\r\n.chat_loader {\r\n  box-sizing: border-box;\r\n  display: flex;\r\n  width: 100%;\r\n  height: 24px;\r\n  align-items: center;\r\n  justify-content: center;\r\n}\r\n\r\n@-webkit-keyframes ball-pulse-sync {\r\n  20% {\r\n    -webkit-transform: translateY(5px);\r\n    transform: translateY(5px);\r\n  }\r\n\r\n  40% {\r\n    -webkit-transform: translateY(-5px);\r\n    transform: translateY(-5px);\r\n  }\r\n\r\n  60% {\r\n    -webkit-transform: translateY(5px);\r\n    transform: translateY(5px);\r\n  }\r\n\r\n  80% {\r\n    -webkit-transform: translateY(-5px);\r\n    transform: translateY(-5px);\r\n  }\r\n\r\n  100% {\r\n    -webkit-transform: translateY(0);\r\n    transform: translateY(0);\r\n  }\r\n}\r\n\r\n@keyframes ball-pulse-sync {\r\n  20% {\r\n    -webkit-transform: translateY(5px);\r\n    transform: translateY(5px);\r\n  }\r\n\r\n  40% {\r\n    -webkit-transform: translateY(-5px);\r\n    transform: translateY(-5px);\r\n  }\r\n\r\n  60% {\r\n    -webkit-transform: translateY(5px);\r\n    transform: translateY(5px);\r\n  }\r\n\r\n  80% {\r\n    -webkit-transform: translateY(-5px);\r\n    transform: translateY(-5px);\r\n  }\r\n\r\n  100% {\r\n    -webkit-transform: translateY(0);\r\n    transform: translateY(0);\r\n  }\r\n}\r\n\r\n.ball-pulse-sync>div:nth-child(1) {\r\n  -webkit-animation: ball-pulse-sync 1s -0.36s infinite ease-in-out;\r\n  animation: ball-pulse-sync 1s -0.36s infinite ease-in-out;\r\n}\r\n\r\n.ball-pulse-sync>div:nth-child(2) {\r\n  -webkit-animation: ball-pulse-sync 1s -0.27s infinite ease-in-out;\r\n  animation: ball-pulse-sync 1s -0.27s infinite ease-in-out;\r\n}\r\n\r\n.ball-pulse-sync>div:nth-child(3) {\r\n  -webkit-animation: ball-pulse-sync 1s -0.18s infinite ease-in-out;\r\n  animation: ball-pulse-sync 1s -0.18s infinite ease-in-out;\r\n}\r\n\r\n.ball-pulse-sync>div:nth-child(4) {\r\n  -webkit-animation: ball-pulse-sync 1s -0.09s infinite ease-in-out;\r\n  animation: ball-pulse-sync 1s -0.09s infinite ease-in-out;\r\n}\r\n\r\n.ball-pulse-sync>div:nth-child(5) {\r\n  -webkit-animation: ball-pulse-sync 1s 0s infinite ease-in-out;\r\n  animation: ball-pulse-sync 1s 0s infinite ease-in-out;\r\n}\r\n\r\n.ball-pulse-sync>div {\r\n  width: 5px;\r\n  height: 5px;\r\n  border-radius: 100%;\r\n  margin: 0px;\r\n  -webkit-animation-fill-mode: both;\r\n  animation-fill-mode: both;\r\n  display: inline-block;\r\n}\r\n\r\n.text-us-btn {\r\n  border-radius: 7px;\r\n  border: solid 1px #e4e4e4;\r\n  background-color: #fff;\r\n  padding: 10px 20px;\r\n  color: #212529;\r\n  margin-bottom: 15px;\r\n  cursor: pointer;\r\n  height: 55px;\r\n  align-items: center;\r\n  justify-content: center;\r\n  display: flex;\r\n}\r\n\r\n.radio-button-toolbar {\r\n  display: grid;\r\n  grid-template-columns: 1fr 1fr;\r\n  gap: 10px;\r\n}\r\n\r\n.radio-button-toolbar input[type=\"radio\"] {\r\n  opacity: 0;\r\n  position: fixed;\r\n  width: 0;\r\n}\r\n\r\n.radio-button-toolbar label {\r\n  display: block;\r\n  background-color: #fff;\r\n  padding: 13px;\r\n  font-size: 11px;\r\n  border: 1px solid #dedede;\r\n  border-radius: 5px;\r\n  margin: 0;\r\n  text-align: center;\r\n  cursor: pointer;\r\n}\r\n\r\n.radio-button-toolbar label:hover {\r\n  background-color: #fefefe;\r\n}\r\n\r\n.radio-button-toolbar input[type=\"radio\"]:checked+label {\r\n  background-color: #f3f3f3;\r\n  border-color: #333;\r\n  font-weight: 600;\r\n}\r\n\r\n.input__hold input:focus {\r\n  outline: none;\r\n}\r\n\r\n.note-info-text.info_text {\r\n  font-size: 11px !important;\r\n  color: #999;\r\n}\r\n\r\n.salestextareamessage.error {\r\n  border: 1px solid red !important;\r\n}\r\n\r\n.my-custom-margin {\r\n  margin: 40px 0 35px 0;\r\n}\r\n\r\n.custom-padding-t30-b60 {\r\n  padding: 30px 0 60px 0;\r\n}\r\n\r\n.custom-padding-t30 {\r\n  padding-top: 35px;\r\n}\r\n\r\n.custom-padding-t30-b35 {\r\n  padding: 30px 0 5px 0;\r\n}\r\n\r\n@media (min-width: 1900px) {\r\n  .send-btn-con .text-send-btn {\r\n    height: 50px;\r\n  }\r\n}\r\n\r\n.new_text_us_form .input__contA {\r\n  width: 100%;\r\n  display: grid;\r\n  grid-template-columns: 1fr 1fr;\r\n  gap: 10px;\r\n  justify-content: flex-start;\r\n  align-items: center;\r\n}\r\n\r\n.new_text_us_form.mobile-number-box .name-input.rounded-inputs {\r\n  border-radius: 5px !important;\r\n}\r\n\r\n.new_text_us_form.mobile-number-box .input__hold {\r\n  margin: 0 0 10px 0;\r\n}\r\n\r\n.new_text_us_form.mobile-number-box .mobile-number {\r\n  color: #999;\r\n  margin: 5px 0;\r\n}\r\n\r\n.showOtherTextForm .text__conversation__block.other_Option_Text {\r\n  height: auto !important;\r\n}\r\n</style>\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
